import cn from 'classnames';
import React from 'react';
import { enableScroll } from '@shared/helpers';
import { useAppDispatch, useAppSelector } from 'library/hooks/common';
import { hidePopup, openNotifyModal, selectPopupProps } from 'library/redux/modal';
import * as st from './Popup.module.scss';

const Popup: React.FC = () => {
  const dispatch = useAppDispatch();
  const props = useAppSelector(selectPopupProps);

  React.useEffect(() => {
    dispatch(
      openNotifyModal({
        title: props.type === 'error' ? 'Ошибка' : 'Уведомление',
        text: props.text,
        confirmText: 'Ок',
      })
    );
    // dispatch()
    // setTimeout(() => {
    //   enableScroll();
    //   dispatch(hidePopup());
    // }, 3000);
  }, [dispatch, props]);

  return (
    <></>
    // <div className={cn(st.popup, st[props.type])}>{props.text}</div>
  );
};

export default Popup;
